// @greenlight-spec: 17-code-organization.md
// @greenlight-spec: 28-it-dashboard-ui.md
import { initQueryClient } from '@ts-rest/react-query';
import { contract } from '@greenlight/contract';

export const api = initQueryClient(contract, {
  baseUrl: '',
  baseHeaders: {
    'content-type': 'application/json',
  },
  credentials: 'include',
});

export type Api = typeof api;
